import { APICompsSchema } from "@unit/apis";

export const LOCAL_STORAGE_ACCESS_TOKEN_KEY = "518bb79dc9bb888f72f686ce77f5feb8";
export const LOCAL_STORAGE_ACCESS_TOKEN_EXPIRES_AT_KEY = "381dd579d84447c7701272c76b109f40";

export const SNACK_BAR_AUTO_HIDE_DURATION_M_SEC = 5000;

export const STAFF_STORE_LIST_MONTHS_OFFSET = 1;
export const elevationApp = 3;
export const QUERY_MAX_LIMIT = 20000;
export const QUERY_INTERVAL_LIMIT = 2000;
export const INOPERABLE_INFLUENCER_STATUSES: APICompsSchema["InfluencerStatusEnum"][] = ["canceled"];

export const genderSelectModel: { type: string; value: string }[] = [
  {
    type: "male",
    value: "男性",
  },
  {
    type: "female",
    value: "女性",
  },
  {
    type: "other",
    value: "無回答",
  },
];

export const organizationTypeSelectModel: { type: APICompsSchema["OrganizationTypeEnum"]; value: string }[] = [
  {
    type: "company",
    value: "会社",
  },
  {
    type: "soleProprietor",
    value: "個人事業",
  },
];

export const StaffRoleEnumModel: { type: APICompsSchema["StaffRoleEnum"]; value: string }[] = [
  {
    type: "general",
    value: "一般スタッフ",
  },
  {
    type: "storeManager",
    value: "店長（ストアマネージャー）",
  },
  {
    type: "supervisor",
    value: "全体責任者",
  },
];
